/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { GenerateOnboardingBioApiArg, OnboardingGenerateBioResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    generateOnboardingBio: build.mutation<OnboardingGenerateBioResponse, GenerateOnboardingBioApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/v1/onboarding/generate-bio`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as generateOnboardingBioApi };
export const { useGenerateOnboardingBioMutation } = injectedRtkApi;
